<template>
  <section class="parties-of-lawsuit-card">
    <header class="card-header">
      <div v-if="isCessation(data)">
        <h2 class="party-name">
          {{ getCasePartyName(data) }}
        </h2>
        <label class="lawsuit-info">
          <span
            v-if="getPartyTypeById(data.partyType)"
            class="info-label"
          >{{ getPartyTypeById(data.partyType) }}</span>
          <span
            v-if="data.cessationJudgmentNumber"
            class="info-label"
          >{{ local.casePartyCard.judgmentCode + ' : ' + data.cessationJudgmentNumber }}</span>
          <span
            v-if="data.cessationCourtId"
            class="info-label"
          >{{ local.casePartyCard.courtName +' : ' + getCasePartyCourtName(data) }}</span>

          <span
            v-if="data.cessationDeedNumber"
            class="info-label"
          >{{ local.casePartyCard.deedNumber +' : ' + data.cessationDeedNumber }}</span>
          <span
            v-if="data.cessationIssuer"
            class="info-label"
          >{{ local.casePartyCard.issuer +' : '+ data.cessationIssuer }}</span>
          <span
            v-if="data.cessationOther"
            class="info-label"
          >{{ local.casePartyCard.other }}</span>
          <span
            v-if="data.cessationOther"
            class="info-label"
          >{{ data.cessationOther }}</span>
        </label>
      </div>
      <div v-else>
        <h2 class="party-name">
          {{ hasHeirs && isPerson(data) && isInheritor(data) ? 'ورثة' : '' }} {{ getCasePartyName(data) }}
        </h2>

        <label class="lawsuit-info">
          <span
            v-if="isDevelopment() && data.objectKey"
            class="info-label"
          >{{ data.objectKey }}</span>
           <span
            v-if="getPartyRoleById(data.subPartyRoleId)"
            class="info-label"
          >{{  'الصفة'+ ' : ' + getPartyRoleById(data.subPartyRoleId)  }}</span>
          <span
            v-if="getPartyTypeById(data.partyType)"
            class="info-label"
          >{{ isOrganization(data) ? 'صاحب مؤسسة: '+ data.name : getPartyTypeById(data.partyType) }}</span>
          <span
            v-if="isOrganization(data) && data.socialId"
            class="info-label"
          >{{ 'هوية صاحب المؤسسة : ' + getCasePartyId({ ...data, partyType:partyTypeEnum.person,isOrganizationOwner:false }).id }}</span>
          <span
            v-if="getCasePartyId(data).type && getCasePartyId(data).id && socialIdTypeEnum[getCasePartyId(data).type]"
            class="info-label"
          >{{ socialIdTypeEnum[getCasePartyId(data).type] + ' : ' + getCasePartyId(data).id }}</span>
          <span
            v-if="data.nationalityCountryId && (isPerson(data) || isOrganization(data) || isLiquidatorOrJudicialGuard(data))"
            class="info-label"
          >{{ 'الجنسية : ' + getCasePartyNationality(data) }}</span>
          <span
            v-if="getCasePartyCity(data)"
            class="info-label"
          >{{ 'المدينة : ' + getCasePartyCity(data) }}</span>
          <span
            v-if="data.commercialRegistrationTypeId != null && !isOrganizationOwner(data)"
            class="info-label"
          >{{ local.lawsuitRequest.currentUserAsCaseParty.commercialRegistrationTypeName + ' : ' +getCommercialRegistrationType(data.commercialRegistrationTypeId) }}</span>
          <span
            v-if="isInheritor(data)"
            class="info-label"
          >{{ local.common.casePartyRoles.inheritor }}</span>
        </label>
      </div>
      <div class="pull-left card-actions">
        <template v-if="false">
          <naj-button color="error">
            {{ local.common.delete }}
          </naj-button>
        </template>
      </div>
      <div class="pull-left card-collapse">
        <span v-if="data.objectKey">
          <naj-icon
            v-if="!disableEdit()"
            icon="pencil"
            size="14px"
            bg-color="#fff"
            tooltip-message="تعديل"
            border
            rounded
            @click="$parent.$emit('update-case-party', { objectKey: data.objectKey })"
          ></naj-icon>
          <naj-icon
            v-if="!disableEdit()"
            icon="delete"
            size="14px"
            bg-color="#fff"
            tooltip-message="حذف"
            border
            rounded
            @click="$parent.$emit('remove-case-party', { objectKey: data.objectKey })"
          ></naj-icon>
        </span>
        <naj-icon
          v-if="
            !disableEdit() ||
              (disableEdit() && data.representatives && Object.keys(data.representatives).length)
          "
          :icon="cardCollapse ? `chevron-down` : `chevron-up`"
          size="14px"
          bg-color="#fff"
          border
          rounded
          @click="cardCollapse = !cardCollapse"
        ></naj-icon>
      </div>
    </header>
    <article
      v-show="!cardCollapse"
      v-if="!disableEdit() || (disableEdit() && viewRepresentativesInViewMode(data))"
      class="card-body"
    >
      <ul class="representative-list list-unstyled">
        <li
          v-if="data.socialId && isFirm(data)"
          class="list-item"
        >
          <header class="card-header">
            <div>
              <h3 class="party-name">
                {{ getCasePartyName({ ...data, partyType:partyTypeEnum.person }) }}
              </h3>

              <div class="lawsuit-info">
                <span class="info-label">{{ getManagerTitle(data) }}</span>
                <span class="info-label">{{ socialIdTypeEnum[data.socialIdType] + ' : ' + data.socialId }}</span>
              </div>
            </div>
          </header>
        </li>

        <li
          v-for="representative in data.representatives"
          :key="representative.objectKey"
          class="list-item"
        >
          <header class="card-header">
            <div>
              <h3 class="party-name">
                {{ getCasePartyName(representative) }}
              </h3>

              <div class="lawsuit-info">
                <span
                  v-if="isDevelopment() && representative.objectKey"
                  class="info-label"
                >{{ representative.objectKey }}</span>
                <span
                  class="info-label type"
                  :class="`type-${representative.casePartyRole}`"
                >
                  {{
                    local.common.casePartyRoles[casePartyRoleByIdEnum[representative.casePartyRole]]
                  }}
                </span>
                <span
                  v-if="getPartyTypeById(representative.partyType)"
                  class="info-label"
                >{{ isOrganization(representative) ? 'صاحب مؤسسة: '+ representative.name : getPartyTypeById(representative.partyType) }}</span>
                <span
                  v-if="isOrganization(representative) && representative.socialId"
                  class="info-label"
                >{{ 'هوية صاحب المؤسسة : ' + getCasePartyId({ ...representative, partyType:partyTypeEnum.person,isOrganizationOwner:false }).id }}</span>
                <span
                  v-if="getCasePartyId(representative).type && getCasePartyId(representative).id"
                  class="info-label"
                >{{ socialIdTypeEnum[getCasePartyId(representative).type] + ' : ' + getCasePartyId(representative).id }}</span>
                <span
                  v-if="representative.nationalityCountryId && isPersonOrOrganizationOwner(representative)"
                  class="info-label"
                >{{ 'الجنسية : ' + getCasePartyNationality(representative) }}</span>
                <naj-button
                  v-if="representative.attorneyTypeId == writingsOfJusticeEnum.internalAttorney || representative.attorneyTypeId == writingsOfJusticeEnum.externalAttorney"
                  size="small"
                  icon="mdi-eye-outline"
                  class="view-attorney-text"
                  :loading="loadAttorney"
                  @click="
                    viewAttorney(
                      representative.attorneyNumber,
                      representative.socialId,
                      getAttorneyClientSocialId(data),
                      representative.isTraineeLawyer ? writingsOfJusticeEnum.internalAttorney : representative.attorneyTypeId
                    )
                  "
                >
                  {{ representative.attorneyTypeId == writingsOfJusticeEnum.internalAttorney || representative.isTraineeLawyer ? local.attorney.attorneyText: local.attorney.attorneyDoc }}
                </naj-button>
              </div>
            </div>
            <div class="pull-left card-collapse">
              <span v-if="representative.objectKey && (!otherPartiesSide||isLiquidatorOrJudicialGuard(data))">
                <naj-icon
                  v-if="!disableEdit()"
                  icon="pencil"
                  size="14px"
                  bg-color="#fff"
                  tooltip-message="تعديل"
                  border
                  rounded
                  @click="
                    $parent.$emit('update-case-party-representative', {
                      objectKey: representative.objectKey,
                    })
                  "
                ></naj-icon>
                <naj-icon
                  v-if="!disableEdit()"
                  icon="delete"
                  size="14px"
                  bg-color="#fff"
                  tooltip-message="حذف"
                  border
                  rounded
                  @click="
                    $parent.$emit('remove-case-party-representative', {
                      objectKey: representative.objectKey,
                    })
                  "
                ></naj-icon>
              </span>
              <naj-icon
                v-if="
                  !disableEdit() ||
                    (disableEdit() &&
                      representative.representatives &&
                      Object.keys(representative.representatives).length)
                "
                :icon="cardCollapse ? `chevron-down` : `chevron-up`"
                size="14px"
                bg-color="#fff"
                border
                rounded
                @click="card2Collapse = !card2Collapse"
              ></naj-icon>
            </div>
          </header>

          <article
            v-show="!card2Collapse"
            v-if="
              !disableEdit() ||
                (disableEdit() &&
                  representative.representatives &&
                  Object.keys(representative.representatives).length)
            "
            class="card-body"
          >
            <ul class="representative-list list-unstyled">
              <li
                v-for="representative2 in representative.representatives"
                :key="representative2.objectKey"
                class="list-item"
              >
                <header class="card-header">
                  <div>
                    <h4 class="party-name">
                      {{ getCasePartyName(representative2) }}
                    </h4>

                    <label class="lawsuit-info">
                      <span
                        v-if="isDevelopment() && representative2.objectKey"
                        class="info-label"
                      >{{ representative2.objectKey }}</span>
                      <span
                        class="info-label type"
                        :class="`type-${representative2.casePartyRole}`"
                      >
                        {{
                          local.common.casePartyRoles[
                            casePartyRoleByIdEnum[representative2.casePartyRole]
                          ]
                        }}
                      </span>
                      <span
                        v-if="getPartyTypeById(representative2.partyType)"
                        class="info-label"
                      >{{ isOrganization(representative2) ? 'صاحب مؤسسة: '+ representative2.name : getPartyTypeById(representative2.partyType) }}</span>
                      <span
                        v-if="isOrganization(representative2) && representative2.socialId"
                        class="info-label"
                      >{{ 'هوية صاحب المؤسسة : ' + getCasePartyId({ ...representative2, partyType:partyTypeEnum.person,isOrganizationOwner:false }).id }}</span>
                      <span
                        v-if="getCasePartyId(representative2).type && getCasePartyId(representative2).id"
                        class="info-label"
                      >{{ socialIdTypeEnum[getCasePartyId(representative2).type] + ' : ' + getCasePartyId(representative2).id }}</span>
                      <span
                        v-if="representative2.nationalityCountryId && isPersonOrOrganizationOwner(representative2)"
                        class="info-label"
                      >{{ 'الجنسية : ' + getCasePartyNationality(representative2) }}</span>
                      <span
                        v-if="isInheritor(data)"
                        class="info-label"
                      >{{ local.common.casePartyRoles.inheritor }}</span>
                    </label>
                  </div>
                  <div class="pull-left card-collapse">
                    <span v-if="representative2.objectKey && (!otherPartiesSide||isLiquidatorOrJudicialGuard(data))">
                      <naj-icon
                        v-if="!disableEdit()"
                        icon="pencil"
                        size="14px"
                        bg-color="#fff"
                        tooltip-message="تعديل"
                        border
                        rounded
                        @click="
                          $parent.$emit('update-case-party-representative', {
                            objectKey: representative2.objectKey,
                          })
                        "
                      ></naj-icon>
                      <naj-icon
                        v-if="!disableEdit()"
                        icon="delete"
                        size="14px"
                        bg-color="#fff"
                        tooltip-message="حذف"
                        border
                        rounded
                        @click="
                          $parent.$emit('remove-case-party-representative', {
                            objectKey: representative2.objectKey,
                          })
                        "
                      ></naj-icon>
                    </span>
                  </div>
                </header>
              </li>
              <li
                v-if="!disableEdit() && (!otherPartiesSide||isLiquidatorOrJudicialGuard(data))"
                v-show="card2Showed[representative.objectKey]"
                class="list-item choose-representative-type"
              >
                <representative-type-selector
                  :related-case-party-object-key="representative.objectKey"
                  :related-case-party-type="representative.partyType"
                  :related-case-party-role="representative.casePartyRole"
                  :related-of-related-case-party-role="data.casePartyRole"
                  :related-of-related-case-party-type="data.partyType"
                  @show="isShowed => (card2Showed[representative.objectKey] = isShowed)"
                ></representative-type-selector>
              </li>
            </ul>
          </article>
        </li>
        <li
          v-if="!disableEdit() && (!otherPartiesSide||isLiquidatorOrJudicialGuard(data)) && (!isInheritor(data) || isOrganizationOwner(data))"
          v-show="cardShowed"
          class="list-item choose-representative-type"
        >
          <representative-type-selector
            :related-case-party-object-key="data.objectKey"
            :related-case-party-role="data.casePartyRole"
            :related-of-related-case-party-type="data.partyType"
            @show="isShowed => (cardShowed = isShowed)"
          ></representative-type-selector>
        </li>
      </ul>
    </article>
  </section>
</template>

<script>
import RepresentativeTypeSelector from './representative-type-selector';
import {
  casePartyRoleByIdEnum,
  partyTypeEnum,
  socialIdTypeEnum,
  writingsOfJusticeEnum,
  commercialRegistrationTypes,
} from '@/helpers/enum';
import {
  isPerson,
  getCasePartyName,
  getCasePartyId,
  isProsecutor,
  isOrganization,
  isFirm,
  isGovernment,
  isAssociation,
  isInheritor,
  isOrganizationOwner,
  isPersonOrOrganizationOwner,
  isCessation,
  isResident,
  isForeignCompany,
  isLiquidatorOrJudicialGuard,
} from '../../helpers/utils';
import { isDevelopment } from '@/helpers/utils';
import { createNamespacedHelpers } from 'vuex';

const { mapGetters, mapActions } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  inject: ['mode'],
  components: { RepresentativeTypeSelector },
  props: {
    data: Object,
    disabled: Boolean,
    otherPartiesSide: Boolean,
    partiesList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      socialIdTypeEnum,
      casePartyRoleByIdEnum,
      partyTypeEnum,
      cardShowed: false,
      cardCollapse: false,
      card2Showed: {},
      card2Collapse: false,
      isPerson,
      isProsecutor,
      getCasePartyId,
      isDevelopment,
      isOrganization,
      isFirm,
      isGovernment,
      isAssociation,
      isInheritor,
      isOrganizationOwner,
      isPersonOrOrganizationOwner,
      isCessation,
      isLiquidatorOrJudicialGuard,
      writingsOfJusticeEnum,
      commercialRegistrationTypes,
      loadAttorney: false,
    };
  },
  created() {
    this.getPartyTypes();
    this.getPrisonerStatuses();
    this.getCountries();
    this.getCities();
    this.getAllCourts();
    this.getGovernmentAgencies();
    this.getEmbassies();
    this.getAssociations();
    this.getPartyAttributesPartyRoles();
  },
  computed: {
    ...mapGetters(['isEditMode']),
    ...mapLUTState([
      'socialTypes',
      'governmentAgencies',
      'embassies',
      'associations',
      'partyTypes',
      'prisonerStatuses',
      'countries',
      'cities',
      'allCourts',
      'partyAttributesPartyRoles'
    ]),
    hasHeirs() {
      return this.partiesList.some(x => x.relatedDeceasedSocialId === this.data.socialId);
    },
  },
  methods: {
    ...mapActions(['setRequestApplicant']),
    ...mapLUTActions([
      'getGovernmentAgencies',
      'getEmbassies',
      'getAssociations',
      'getPartyTypes',
      'getPrisonerStatuses',
      'getCountries',
      'getCities',
      'getAllCourts',
      'getPartyAttributesPartyRoles'
    ]),
    getCasePartyName(caseParty) {
      return getCasePartyName(
        caseParty,
        isAssociation(caseParty)
          ? this.associations
          : (this.governmentAgencies || []).concat(this.embassies || [])
      );
    },
    getPrisonerStatusById(id) {
      const status = this.prisonerStatuses.find(ps => ps.id === id);
      return status ? status.name : '';
    },
    getCasePartyCourtName(data) {
      const court = this.allCourts.find(c => c.id === data.cessationCourtId);
      return court ? court.name : '';
    },
    getPartyTypeById(id) {
      const partyType = this.partyTypes.find(pt => pt.id === id);
      return partyType ? id !== partyTypeEnum.person ? partyType.name : 'فرد' : '';
    },
    getCasePartyNationality(caseParty) {
      if (!caseParty) return;
      const country = this.countries.find(c => c.id === caseParty.nationalityCountryId);
      return country ? country.name : '';
    },
    getCommercialRegistrationType(commercialRegistrationTypeId) {
      if (commercialRegistrationTypeId == null) '';
      const type = this.commercialRegistrationTypes.find(c => c.id === commercialRegistrationTypeId);
      return type ? type.name : '';
    },
    getCasePartyCity(caseParty) {
      if (!caseParty || caseParty.unknownAddress) return;
      let addressObj = (caseParty.residenceAddress || caseParty.placeAddress || {});
      if (isResident(caseParty) || isFirm(caseParty) || isForeignCompany(caseParty) || isOrganization(caseParty))
        addressObj = (caseParty.nationalAddress || addressObj);
      if (addressObj.city) return addressObj.city;
      const city = this.cities.find(c => c.id === addressObj.cityId);
      return city ? city.name : '';
    },
    onChangeRequestApplicant(isChecked, objectKey) {
      this.setRequestApplicant(isChecked ? objectKey : null);
    },
    viewAttorney(attorneyCode, agentSocialId, clientSocialId, attorneyTypeId) {
      this.$emit('viewAttorney', {
        attorneyCode,
        agentSocialId,
        clientSocialId,
        attorneyTypeId,
      });
    },
    getAttorneyClientSocialId(caseParty) {
      if (isOrganization(caseParty)) {
        return caseParty.socialId;
      }
      return caseParty.commercialRegistrationNumber || caseParty.socialId;
    },
    getManagerTitle(data) {
      if (isOrganization(data)) return this.local.organizationData.organizationManager;
      if (isFirm(data)) return this.local.firmData.firmManager;
    },
    viewRepresentativesInViewMode(data) {
      return (
        (data.representatives && Object.keys(data.representatives).length) ||
        isOrganization(data) ||
        isFirm(data)
      );
    },
    disableEdit() {
      return this.mode.isViewMode || this.disabled;
    },
    getPartyRoleById(id) {
      const partyRole = this.partyAttributesPartyRoles.find(pr => pr.id === id);
      return partyRole ? partyRole.name : '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/partials/_vars.scss';
.parties-of-lawsuit-card {
  border: 2px solid #f1f1f2;
  margin-bottom: 15px;

  .party-name {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 400px;
    font-size: 24px;
  }
}
.card-header {
  background-color: #fcfcfc;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .card-collapse,
  .card-collapse > * {
    display: flex;
    justify-content: space-between;
  }
  .lawsuit-info {
    display: block;
    margin-top: 0;
    margin-bottom: 20px;
    .info-label {
      display: inline-table;
      padding: 6px 8px;
      margin-left: 5px;
      font-size: 13px;
      background-color: #f3f3f8;
      border-radius: 15.5px;
      color: #5b607a;
    }
    .type {
      color: #fff;
    }
    .type-2 {
      background-color: #5f0808 !important;
    }
    .type-5 {
      background-color: #cd6133 !important;
    }
    .type-10 {
      background-color: #34ace0 !important;
    }
    .type-11 {
      background-color: #cc8e35 !important;
    }
    .type-55 {
      background-color: #777b4b !important;
    }
    .type-56 {
      background-color: #f0c36d !important;
    }
    .type-2000 {
      background-color: #706fd3 !important;
    }
    .type-10005 {
      background-color: #2020a798;
      color: #fff;
    }
  }
}
::v-deep .request-applicant {
  display: inline-block;
  font-weight: 600;
  .theme--light.v-label {
    top: -10px !important;
    right: 0 !important;
    color: #5b607a;
  }
  .v-icon.v-icon {
    margin: 0;
  }
  .v-messages {
    min-height: 0 !important;
  }
  .v-input--selection-controls__input {
    margin-right: 8px;
    margin-left: 8px;
    position: relative;
    top: -11px;
  }
}
.card-body {
  padding: 0 25px 15px 0;
  background-color: #fcfcfc;
}
.representative-list {
  border-right: 2px solid #e2e2e2;
  padding: 15px 25px 0 10px;
  .list-item {
    position: relative;
    margin-bottom: 5px;
    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    &:before {
      right: -35px;
      z-index: 2;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background-color: #fff;
      border: 2px solid #e2e2e2;
    }
    &:after {
      left: 100%;
      z-index: 1;

      width: 25px;
      height: 2px;
      background-color: #e2e2e2;
    }
  }
}
.parties-of-lawsuit-card ::v-deep {
  .v-button-wrapper:not(.view-attorney-text) {
    .v-btn {
      min-height: 46px !important;
      height: 46px !important;
      top: -1px !important;
    }
  }
  .view-attorney-text {
    .icon {
      width: auto !important;
      height: auto !important;
      position: relative;
      right: auto !important;
      background-color: transparent !important;
      font-size: 18px;
      margin-right: 10px;
    }
  }
}
</style>
